/// <reference types="vite/client" />

import eye from './eye.svg?raw'
import eyeOff from './eye-off.svg?raw'
import globe from './globe.svg?raw'
import lineSpacing from './line-spacing.svg?raw'
import scrollDown from './scroll-down.svg?raw'
import share from './share.svg?raw'
import spacingTighter from './spacing-tighter.svg?raw'
import spacingWider from './spacing-wider.svg?raw'
import statusError from './status-error.svg?raw'
import statusLoading from './status-loading.svg?raw'
import statusSuccess from './status-success.svg?raw'
import statusWarning from './status-warning.svg?raw'
import textLarger from './text-larger.svg?raw'
import textSmaller from './text-smaller.svg?raw'
import textsize from './textsize.svg?raw'
import tts from './tts.svg?raw'
import ttsOff from './tts-off.svg?raw'

/** v3 icon 原始 SVG 字串（皆為 currentColor），用 v-html 內嵌，不要用 img src。 */
export const icons = {
	'eye': eye,
	'eye-off': eyeOff,
	'globe': globe,
	'line-spacing': lineSpacing,
	'scroll-down': scrollDown,
	'share': share,
	'spacing-tighter': spacingTighter,
	'spacing-wider': spacingWider,
	'status-error': statusError,
	'status-loading': statusLoading,
	'status-success': statusSuccess,
	'status-warning': statusWarning,
	'text-larger': textLarger,
	'text-smaller': textSmaller,
	'textsize': textsize,
	'tts': tts,
	'tts-off': ttsOff,
} as const

/** @type {IconName} 圖示名稱聯集，取值為 icons 物件的所有 key */
export type IconName = keyof typeof icons
